import XLSX from 'xlsx';
import dayjs from "dayjs";
import { useState, useEffect } from "react";

import { useSystemPrompt } from "../../useSystemPrompt";
import { useReportQuery, reportTypes, reportScopes } from "../../useReportQuery";

let _excelHeader = [
    "No.",
    "Doc No.",
    "Doc Date",
    "Location",
    "Profile",
    "Address #1",
    "Address #2",
    "Postcode",
    "Area",
    "State",
    "Country",
    "Created By",
    "Created Date"
]


export function useReportDeliveryOrderExcelExport() {

    // console.log('test report', 'aa');
    // console.log('filterValues', filterValues);
    // console.log('fileName', config.generateFileName);
    const [excelData, setExcelData] = useState([])
    const { promptMessage } = useSystemPrompt();
    const {
        isLoading,
        onSubmit
    } = useReportQuery({ reportType: reportTypes.sales.deliveryOrder.id, reportScope: reportScopes.sales });

    const fetchReportData = async ({ filterValues }) => {
        // console.log('reach fetchreport');
        const paginationModel = {
            started: false,
            page: 0,
            pageSize: 10000,
            rowCount: 0
        };

        try {
            let { data } = await onSubmit({
                values: filterValues,
                paginationModel
            })
            let listData = data?.rows;
            // console.log('report excel data', listData);
            setExcelData(listData);
            return {
                listData
            };


        } catch (error) {
            promptMessage(false, `${error?.message}`)
            return { listData: [] };
        }


    }

    const _toDecimal3 = (val) => {
        return parseFloat(val).toFixed(3)
    }

    const getColsDefault = () => {

        let _width = {
            tiny: 5,
            short: 10,
            normal: 15,
            long: 30,
        }

        let cols = [
            { wch: _width.tiny },
            { wch: _width.normal },
            { wch: _width.normal },
            { wch: _width.long + 10 },
            { wch: _width.long + 10 },

            { wch: _width.long },
            { wch: _width.long },
            { wch: _width.normal },
            { wch: _width.normal },
            { wch: _width.normal },
            { wch: _width.normal },
            { wch: _width.normal },
            { wch: _width.normal }

        ]

        return cols
    }

    const buildBodyHeader = () => {
        return [_excelHeader]
    }


    const buildBodySection = ({
        filterValues,
        listData,
    }) => {
        // console.log('listData', listData);
        let data = [];
        let indexNoDisplay = 0;
        listData.forEach((item, index1) => {

            indexNoDisplay += 1;
            let itemData = [
                (indexNoDisplay),
                item.doc_number,
                item.doc_date,
                item.location_name,
                item.profile_name,
                item.delivery_address_1,
                item.delivery_address_2,
                item?.delivery_postcode,
                item?.delivery_area,
                item?.delivery_state_name,
                item?.delivery_country_name,
                item.ax_createusername,
                item.ax_createdatetime
            ]

            data = [...data, itemData]
        })

        return data
    }


    // for export excel
    const generateExcel = async ({
        filterValues,
        config = {
            generateFileName: ''
        }
    }) => {

        // console.log('reach generate excel');
        // console.log('file name', config.generateFileName);
        let { listData } = await fetchReportData({ filterValues });


        // console.log('dataProductItems', listData)
        /* array of arrays of data */

        // prepare the datasets
        let rawLines = []
        // let merges = []
        //

        let rawLinesBodyHeader = buildBodyHeader()
        let rawLinesBody = buildBodySection({
            filterValues,
            listData
        })

        // console.log('rawLinesBodyHeader', rawLinesBodyHeader)
        // console.log('rawLinesBody', rawLinesBody)


        // rawLines = [...rawLines, []] // break one line
        rawLines = [...rawLines, ...rawLinesBodyHeader]
        rawLines = [...rawLines, ...rawLinesBody]

        /* create worksheet */
        let ws = XLSX.utils.aoa_to_sheet(rawLines);
        /* create workbook and export */
        let wb = XLSX.utils.book_new();

        // ws["!merges"] = merges
        ws["!cols"] = getColsDefault()

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, `${config?.generateFileName}`);

        return {
            payload: {
                fileName: config?.generateFileName
            }
        }

    }

    return {
        generateExcel
    }

}